module.exports = __webpack_public_path__ + "static/img/m-logo.9905935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m-logo.jpg
// module id = dvPD
// module chunks = 1